import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.create');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-create',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.create/view.scss */
/* src/app/portal.kiosk.create/view.scss: no such file or directory */`],
})
export class PortalKioskCreateComponent implements OnInit {
    @Input() event: any;
    @Input() opts: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
        await this.start();
    }

    public async start() {
        let image = this.event.get("image");

        const fd = new FormData();
        fd.append('mode', this.event.get("mode"));
        fd.append('upload', image, 'captured_image.png');

        let fdurl = wiz.url("upload");
        const { code, data } = await this.service.file.upload(fdurl, fd, async (percent: number, total: number, position: number) => { });

        if (code != 200) {
            await this.service.render(1000);
            await this.start();
            return;
        }

        await this.event.set("result", data);
        await this.event.set("bg", data.generated_image);
        await this.event.view("final");
    }
}

export default PortalKioskCreateComponent;